module.exports = __webpack_public_path__ + "static/Jost-VariableFont_wght-840d6f6f870de1edc73ab1808e536f7e.woff2";